import { Box, useTheme } from "@mui/material";
import Header from "../../components/Header";
import AreaSelector from "../../components/map/AreaSelector";
import { tokens } from "../../theme";

const Geography = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    return (
        <Box mt="20px" marginX="20px">
            <Header title="Geography" subtitle="Simple Geography Chart" />

            <Box
                height="100%"
                width="100%"
                display="flex"
                justifyContent="center"
                alignItems="flex-start"
            >   
            <Box 
                width="73vh"
                borderRadius="10px"
            >
               <AreaSelector/>
            </Box>
            </Box>
        </Box>
    );
};

export default Geography;